module.exports = __webpack_public_path__ + "img/chev-right-yellow.5fae01f1.svg";